module.exports = __webpack_public_path__ + "static/media/Mobile2.f0e97c84.svg";